/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PopoverTrigger/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function PopoverTrigger({
  children,
  viewPath = "/DesignSystem/Popover/PopoverTrigger",
  triggerRef,
  onLeftClick,
  onRightClick,
  cursor = "default",
  onClickUseDiv,
  onKeyUp,
  onFocus,
  onBlur,
  disabled,
  closePopover,
  isSelected
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  return (<React.Fragment
>
<div
  data-testid="PopoverTrigger.Vertical"
  data-view-path={viewPath}
 ref={triggerRef}
 {...isHoveredBind}
 onClick={onLeftClick}
 onContextMenu={onRightClick}
 style={{'--c-1-294COI': cursor}}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 onKeyUp={onKeyUp}
 onFocus={onFocus}
 onBlur={onBlur}
 disabled={disabled}
 closePopover={closePopover}
 stopPropagation={false}
 isSelected={isSelected} isHovered={isHovered} isSelectedHovered={isSelectedHovered}
>
{children}
</Children>
</div>
</React.Fragment>)
}